<template>
  <b-badge pill :variant="variant">
    {{ statusText }}
  </b-badge>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
    statusMap: {
      type: Object,
      required: true,
    },
  },
  computed: {
    variant() {
      return this.statusMap[this.status]?.variant || 'secondary';
    },
    statusText() {
      return this.statusMap[this.status]?.text || this.status;
    },
  },
};
</script>
